import urlJoin from 'url-join';
import { AppSettings } from 'core/AppSettings';
import { getReturnUrl } from 'core/helpers/getReturnUrl';

export function getLoginUrl(): string {
  const allowedUrl = getReturnUrl();
  const encodedReturnUrl = encodeURI(allowedUrl);
  return urlJoin(AppSettings.authUrl, `?ReturnUrl=${encodedReturnUrl}`);
}
